import { Warrior } from '~/../api/common.types';
import OneName from '~/components/naming/OneName';
import TwoName from '~/components/naming/TwoName';
import { getCurrentWarrior } from '~/utils/utils';

function WarriorItem({ warrior }: { warrior: Warrior }) {
  const warriorData = getCurrentWarrior(warrior);

  return (
    <>
      {warriorData.level <= 4 ? (
        <OneName
          warrior={warrior}
          level={warriorData.level}
          key={warrior.warrior_id}
        />
      ) : (
        <TwoName warrior={warrior} key={warrior.warrior_id} />
      )}
    </>
  );
}

function NamingWarriorList({
  warriors,
}: {
  warriors: Array<Warrior> | undefined;
}) {
  if (warriors && !warriors.length) {
    return <></>;
  }

  return (
    <>
      <div className="grid-revive-warriors grid-dub-warriors">
        {warriors?.map((warrior, i) => (
          <WarriorItem warrior={warrior} key={`${i}-${warrior.warrior_id}`} />
        ))}
      </div>
    </>
  );
}

export default NamingWarriorList;
